module.exports = __webpack_public_path__ + "img/newspapers_button_first_down.8597e0dc.png";